if (window.location.href.includes("/loyalty")) {
  const urlParams = new URLSearchParams(window.location.search);
  const email = urlParams.get("email");

  if (email) {
    console.log("Email:", email);

    const emailInput = document.getElementById("email");
    if (emailInput) {
      emailInput.value = email;
    }
  } else {
    console.log("Email parameter not found in the URL.");
  }
}


$(document).ready(function () {
    templateCheck = $('#productPageCheck').val();
    if(templateCheck == '1') {
        $('vipps-button').remove();
    }
});